import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'

import Vuetify from 'vuetify'
import VueWorker from 'vue-worker';
Vue.use(Vuetify)

import VueSidebarMenu from 'vue-sidebar-menu'
import '@fortawesome/fontawesome-free/css/all.css'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
Vue.use(VueSidebarMenu)

import VueRouter from 'vue-router'
Vue.use(VueRouter)

Vue.use(VueWorker);
import { TableComponent, TableColumn } from 'vue-table-component';
import moment from'moment';
Vue.component('table-component', TableComponent);
Vue.component('table-column', TableColumn);

import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)

import Vue2Filters from 'vue2-filters'
Vue.use(Vue2Filters)

import VueCookies from 'vue-cookies'
Vue.use(VueCookies, { expire: '7d'})

//Import Froala Editor
import 'froala-editor/js/plugins.pkgd.min.js';
//Import third party plugins
import 'froala-editor/js/third_party/embedly.min';
import 'froala-editor/js/third_party/font_awesome.min';
import 'froala-editor/js/third_party/spell_checker.min';
import 'froala-editor/js/third_party/image_tui.min';
// Import Froala Editor css files.
import 'froala-editor/css/froala_editor.pkgd.min.css';

// Import and use Vue Froala lib.
import VueFroala from 'vue-froala-wysiwyg'
Vue.use(VueFroala)
Vue.config.productionTip = false

/*const Feathers = require('@feathersjs/feathers');
const rest = require('@feathersjs/rest-client');
const auth = require('@feathersjs/authentication-client');

const feathers = Feathers();
*/

var hashes = {}

String.prototype.hashCode = function() {
    var hash = 0, i, chr;
    if (this.length === 0) return hash;
    for (i = 0; i < this.length; i++) {
        chr   = this.charCodeAt(i);
        hash  = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
};

async function asyncForEach(array, callback) {
    for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array);
    }
}

function equalHash (type, old, newData) {
    var hash = JSON.stringify(newData).hashCode()
    if(hashes[type] != hash) {
        hashes[type] = hash
        return false
    } else {
        return true
    }
}



import feathers from '@feathersjs/client';

const feathersApp = feathers()

const auth = feathers.authentication
const rest = feathers.rest

// Connect to a different URL
//const restClient = rest('http://localhost:3030')
var restClient;

if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
    restClient = rest('http://localhost:5000')
     //restClient = rest('https://api.grouptravelplanners.com')
    console.log('looks like dev enviroment')
} else if (location.hostname === "dev.grouptravelplanners.com") {
    console.log('looks like dev SERVER enviroment')
    restClient = rest('https://devapi.grouptravelplanners.com')
} else {
    restClient = rest('https://api.grouptravelplanners.com')
    startHeartMon()
}


//startHeartMon()

// Configure an AJAX library (see below) with that client
feathersApp.configure(restClient.fetch(window.fetch));

feathersApp.configure(auth({
    storage: window.localStorage
}))

feathersApp.service("structured");

feathersApp.service("notifications");
feathersApp.service("trips");
feathersApp.service("participants");
feathersApp.service("forms");
feathersApp.service("documents");
feathersApp.service("payments");
feathersApp.service("users");
feathersApp.service("businesses");
feathersApp.service("authmanagement");
feathersApp.service("fees");
feathersApp.service("comprehensive");


let globalData = new Vue({
    data: {
        $userData: {},
        $trips: [],
        $payments: [],
        $participants: [],
        $firstRun: true,
        $isParent: true,
        $users: [],
        $busyDialog: false,
        $fees: [],
        $notifications: [],
        $structuredData: {
            trip: {},
            notifications: [],
            participants: [],
            payments: [],
            documents: []
        },
        $filterTripID: undefined,
        $forceSelectTrip: true,
        $forceSetupAgain: false,
    }
});
Vue.mixin({
    computed: {
        $userData: {
            get: function () { return globalData.$data.$userData },
            set: function (data) { globalData.$data.$userData = data; }
        },
        $busyDialog: {
            get: function () { return globalData.$data.$busyDialog },
            set: function (data) { globalData.$data.$busyDialog = data; }
        },
        $firstRun: {
            get: function () { return globalData.$data.$firstRun },
            set: function (data) { globalData.$data.$firstRun = data; }
        },
        $isParent: {
            get: function () { return globalData.$data.$userData.permissions[0] == "adult" },
            set: function (data) { globalData.$data.$isParent = data; }
        },
        $structuredData: {
            get: function () { return globalData.$data.$structuredData },
            set: function (data) {
                globalData.$data.$structuredData = data;
            }
        },
        $forceSelectTrip: {
            get: function () { return globalData.$data.$forceSelectTrip },
            set: function (data) {
                globalData.$data.$forceSelectTrip = data;
            }
        },
        $forceSetupAgain: {
            get: function () { return globalData.$data.$forceSetupAgain },
            set: function (data) {
                globalData.$data.$forceSetupAgain = data;
            }
        },
        $filterTripID: {
            get: function () {
                    return globalData.$data.$filterTripID;
            },
            set: function (data) {
                globalData.$data.$filterTripID = data;
                var vueThis = this
                Vue.nextTick()
                    .then(function () {
                        console.log('FILTER applying', globalData.$data.$filterTripID)

                        if(globalData.$data.$filterTripID._id != globalData.$data.$userData.lastOpenTripID) {
                            console.log('updating last open trip id')
                            vueThis.$services.users.patch(vueThis.$feathers.get('user')._id, {
                                "lastOpenTripID": globalData.$data.$filterTripID._id
                            })
                        }



                        setTimeout(function () {
                        globalData.$data.$busyDialog = true
                            globalData.$data.$participants = undefined
                            globalData.$data.$payments = undefined
                            hashes = {}
                            vueThis.$fetchData()

                        }, 300)
                    })
            }
        }

    },
    methods: {
        $addNotification(toAdd) {
            console.log('adding to notifications', toAdd)
            globalData.$data.$notifications.unshift(toAdd);
            globalData.$data.$structuredData = this.$buildStructuredData('notifs')
        },
        $addParticipant(toAdd) {
            console.log('adding to participants', toAdd)
            globalData.$data.$participants.unshift(toAdd);
            globalData.$data.$structuredData = this.$buildStructuredData()
        },
        $addUser(toAdd) {
            console.log('adding to users', toAdd)
            globalData.$data.$users.unshift(toAdd);
            globalData.$data.$structuredData = this.$buildStructuredData()
        },
        $fetchUserByID(id) {
           // console.log('fetching user by id', id)
            let match = globalData.$data.$users.find(user => user._id === id)
          //  console.log('returning', match)
            return match
        },
        $updatePaymentStatus(paymentInfo) {
            globalData.$data.$payments.find(payment => payment._id === paymentInfo._id).Status = paymentInfo.Status;
            globalData.$data.$payments.find(payment => payment._id === paymentInfo._id).StatusNote = paymentInfo.StatusNote;
            globalData.$data.$payments.find(payment => payment._id === paymentInfo._id).StatusNoteDate = paymentInfo.StatusNoteDate;
            globalData.$data.$structuredData = this.$buildStructuredData()
        },
        $addPayment(toAdd) {
            console.log('adding to payments', toAdd)
            globalData.$data.$payments.unshift(toAdd);
            globalData.$data.$structuredData = this.$buildStructuredData()
        },
        $updateParticipant(id, data) {
            globalData.$data.$participants.forEach((participant, index) => {
                if (participant._id === id) {
                    globalData.$data.$participants[index].email = data.email
                    globalData.$data.$participants[index].phone = data.phone
                    globalData.$data.$participants[index].firstName = data.firstName
                    globalData.$data.$participants[index].middleName = data.middleName
                    globalData.$data.$participants[index].lastName = data.lastName
                    globalData.$data.$participants[index].Occupancy = data.Occupancy
                    globalData.$data.$participants[index].gender = data.gender
                    globalData.$data.$participants[index].allergies = data.allergies
                    globalData.$data.$participants[index].disabled = data.disabled
                    globalData.$data.$participants[index].lateFeesDisabled = data.lateFeesDisabled
                    globalData.$data.$participants[index].notes = data.notes
                }
            })
            globalData.$data.$structuredData = this.$buildStructuredData()
        },
        $waiveFeed(feeToWaive) {
            console.log('waiving fee', feeToWaive)
            globalData.$data.$fees.find(fee => fee._id === feeToWaive._id).Waived = true;
            globalData.$data.$structuredData = this.$buildStructuredData()
        },
        $buildStructuredData() {
            if (globalData.$data.$userData.permissions.includes('testing') && 1==2)             {
                return this.$fetchStructuredData()
            } else {
               return this.$buildStructured()
            }
        },
        $fetchData() {
            console.log('does this user have testing perms?', globalData.$data.$userData.permissions.includes('testing'))
            if (globalData.$data.$userData.permissions.includes('testing') && 1==2)             {
                this.$fetchStructuredData()
            } else {
                this.$fetchDataRawData()
            }
        },
        $fetchStructuredData() {
            this.$services.structured.find().then((result) => {
                console.log('============================')
                console.log('structured result', result)
                console.log('============================')
                globalData.$data.$structuredData = result.$structuredData
                globalData.$data.$participants = result.$participants
                globalData.$data.$users = result.$users
                globalData.$data.$payments = result.$payments
                globalData.$data.$notifications = result.$notifications
                globalData.$data.$fees = result.$fees
                globalData.$data.$trips = result.$trips
                globalData.$data.$busyDialog = false


                console.log('data now is', globalData)
            })
        },
        $fetchDataRawData() {

            console.log('============================')
            console.log('============================')
            console.log('=========FETCH DATA=========')
            console.log('============================')
            console.log('============================')


            //payments participants notifications



            this.$services.trips.find().then((result) => {
                if (!equalHash('trips', globalData.$data.$trips, result.data)) {
                    console.log('----UPDATING TRIPS', result.data)
                    globalData.$data.$trips = result.data

                    if(globalData.$data.$userData.setup && (result.data == undefined || result.data.length == 0)) {
                        console.log('user has no trip now')
                        globalData.$data.$forceSetupAgain = true;
                    }
                    else if(result.data.length < 2) {
                        console.log('user only has one trip now')
                        globalData.$data.$forceSelectTrip = false;
                    }
                    console.log('last opened is', globalData.$data.$userData.lastOpenTripID)



                    if (globalData.$data.$userData.lastOpenTripID != undefined && globalData.$data.$filterTripID == undefined) {
                        globalData.$data.$filterTripID  = result.data.find((trip) => trip._id == globalData.$data.$userData.lastOpenTripID)
                        if(globalData.$data.$filterTripID == undefined) {
                            console.log('filtering on disabled trip')
                            globalData.$data.$filterTripID = result.data[0]
                        }
                    } else if (globalData.$data.$filterTripID == undefined) {
                        globalData.$data.$filterTripID = result.data[0]
                    }


                    //globalData.$data.$structuredData = this.$buildStructuredData()
                }


                if (globalData.$data.$filterTripID == undefined) {
                    globalData.$data.$busyDialog = false
                    globalData.$data.$userData.supportLink = 'mailto:grouptravelplanners@mail.com?subject=IPS Support - General'
                    return
                } else {
                    console.log('filter in place!!!!!!!!',  globalData.$data.$filterTripID._id)
                    globalData.$data.$userData.supportLink = 'mailto:grouptravelplanners@mail.com?subject=IPS Support - Trip #' + globalData.$data.$filterTripID.tripID
                }

                console.log('BEFORE PAYMENTS FIND')

                this.$services.payments.find({
                    query: {
                        Participants: {
                            $elemMatch: {
                                TripID: globalData.$data.$filterTripID._id
                            }
                        },
                        $sort: {
                            Date: -1
                        }
                    }
                }).then((result) => {
                    if (!equalHash('payments', globalData.$data.$payments, result.data)) {
                        console.log('----UPDATING PAYMENTS', result.data)
                        globalData.$data.$payments = result.data
                        globalData.$data.$structuredData = this.$buildStructuredData()
                    }
                })

                /*this.$services.participants.find({
                    query: {
                        TripID: globalData.$data.$filterTripID._id,
                    }
                }).then((result) => {
                    if (!equalHash('participants', globalData.$data.$participants, result.data)) {
                        console.log('----UPDATING PARTICIPANTS', result.data)
                        globalData.$data.$participants = result.data
                        globalData.$data.$structuredData = this.$buildStructuredData()
                    }
                })*/

                this.$services.comprehensive.get(globalData.$data.$filterTripID._id).then((data) => {
                    if (!equalHash('participants', globalData.$data.$participants, data)) {
                        console.log('----UPDATING PARTICIPANTS', JSON.stringify(data[0]))
                        globalData.$data.$participants = data

                        globalData.$data.$structuredData = this.$buildStructuredData()
                    }
                })

                this.$services.users.find().then((result) => {
                    if (!equalHash('users', globalData.$data.$users, result.data)) {
                        console.log('----UPDATING USERS', result.data)
                        globalData.$data.$users = result.data
                        globalData.$data.$structuredData = this.$buildStructuredData()
                    }

                })

                this.$services.notifications.find({
                    query: {
                        $sort: {
                            date: -1
                        }
                    }
                }).then((result) => {
                    if (!equalHash('notifications', globalData.$data.$notifications, result.data)) {
                        console.log('----UPDATING NOTIFICATIONS', globalData.$data.$notifications, result.data)
                        globalData.$data.$notifications = result.data
                        globalData.$data.$structuredData = this.$buildStructuredData()
                    }
                })


                this.$services.fees.find().then((result) => {
                    if (!equalHash('fees', globalData.$data.$fees, result.data)) {
                        console.log('---- UPDATING FEES', result.data)
                        globalData.$data.$fees = result.data
                        globalData.$data.$structuredData = this.$buildStructuredData()

                    }
                })

            })



        },
        $buildStructured() {

            let toReturn = {}

            toReturn.time = moment(new Date()).format('hh:mm A');

            toReturn.participants = []
            toReturn.Disabledparticipants = []
            toReturn.payments = []
            toReturn.trips = []
            toReturn.notifications = []


            toReturn.documents = [],

                this.$services.forms.get("SIlociNJovwKUyxR").then((doc) => {
                    console.log('got the result of the get', doc)

                    if (globalData.$data.$userData.signedDocs != undefined) {
                        //let result = globalData.$data.$userData.signedDocs.find((signedDoc) => signedDoc.form == doc._id)

                        globalData.$data.$userData.signedDocs.forEach((signedDoc) => {
                            //console.log('looking at signed doc', signedDoc )
                            if (signedDoc.form == doc._id) {
                                doc.signed = signedDoc.signed
                                doc.file = signedDoc.file
                            } else {
                                doc.signed = false
                            }

                            doc.docType = (doc.mandatory == true || doc._id == 'SIlociNJovwKUyxR') ? 'Mandatory' : 'Optional'

                            toReturn.documents.push(doc)
                            //console.log('just puched doc', doc)
                        })
                    }

                })


            console.log('---------------------------STARTING', globalData.$data.$filterTripID)

            // console.log('its', globalData.$data.$notifications)

            if (globalData.$data.$participants == undefined ||
                globalData.$data.$payments == undefined ||
                globalData.$data.$notifications == undefined ||
                globalData.$data.$trips == undefined ||
                globalData.$data.$fees == undefined ||
                globalData.$data.$users == undefined) {

                console.log('require data has not been fetched just yet!!!!!!!!!!!!!!!!', globalData.$data)

                return toReturn
            }


            let filterTripID = null

            if (globalData.$data.$filterTripID != undefined) {
                filterTripID = globalData.$data.$filterTripID._id

            }

            // console.log('toReturn.trips')


            toReturn.trips = globalData.$data.$trips

            toReturn.trips.forEach((trip) => {

                if (trip.documents != undefined) {

                    trip.documents.forEach((document)=>{
                        var doc = {
                            name: document.name,
                            _id: document._id
                        }
                        doc.docType = document.mandatory == true ? 'Mandatory' : 'Optional'

                        if (globalData.$data.$userData.signedDocs != undefined) {
                            let result = globalData.$data.$userData.signedDocs.find((signedDoc) => signedDoc.form == doc._id)

                            if (result != undefined) {
                                doc.signed = result.signed
                                doc.file = result.file
                            } else {
                                doc.signed = false
                            }
                        } else {
                            doc.signed = false
                        }


                        toReturn.documents.push(doc)
                    })

                }

                trip.prettyName = trip.tripName + ' (' + trip.tripID + ')'

                trip.quadInstallments = ((Number(trip.quadPrice) - trip.depositAmount) / 4).toFixed(2)
                trip.tripleInstallments = ((Number(trip.triplePrice) - trip.depositAmount) / 4).toFixed(2)
                trip.doubleInstallments = ((Number(trip.doublePrice) - trip.depositAmount) / 4).toFixed(2)
                trip.singleInstallments = ((Number(trip.singlePrice) - trip.depositAmount) / 4).toFixed(2)


                trip.remainingSpacePercent = 100 - ((trip.participantCount / Number(trip.participantLimit)) * 100)
                trip.remainingSpaceSlots = (Number(trip.participantLimit) - trip.participantCount)

                if (trip.remainingSpacePercent < 0) {
                    trip.remainingSpacePercent = 0
                    trip.remainingSpaceSlots = 0
                }


            })


            let releventUsers = null

            if (filterTripID != null) {

                toReturn.selectedTrip = globalData.$data.$trips.find((trip) => trip._id == filterTripID)
                releventUsers = globalData.$data.$users.filter((user)=> user.trips.includes(filterTripID))
                toReturn.notifications = globalData.$data.$notifications
                    .filter((notification) => notification.trip == filterTripID ||
                        (
                            notification.trip == undefined &&
                            releventUsers.find((user)=>user._id === notification.user) !== undefined
                        )
                    )
            } else {
                toReturn.notifications = globalData.$data.$notifications
                releventUsers = users
            }


            // toReturn.notifications.sort(function(a,b){return new Date(b.date) - new Date(a.date)})

            console.log('LOOKING AT PARTICIPANTS', globalData.$data.$participants)
            globalData.$data.$participants.forEach((participant) => {

                if (filterTripID != null && participant.TripID != filterTripID) {
                     console.log('skipping cause filter')
                    return
                }

                let toAdd = participant
            //    toAdd.Payments = []
                toAdd.Fees = []

              //  globalData.$data.$users.find(trip => trip._id === participant.TripID);


              //  console.log('fetching user for this participant', participant)
            
                let parent = this.$fetchUserByID(participant.ParentUser)

                if (parent == undefined) {
                    parent = {
                        email: 'error',
                        phone: 'error'
                    }
                }

                toAdd.parentEmail = parent.email
                toAdd.parentPhone = parent.phone

                toAdd.fullName = participant.firstName + " " + participant.middleName + " " + participant.lastName


                toAdd.phone = toAdd.phone.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');


                toAdd.Trip = globalData.$data.$trips.find(trip => trip._id === participant.TripID);


                toAdd.GroupsPretty = ''

            //    console.log('BEFORE GROUPS PRETTY', toAdd)

                if (toAdd.customOptionsSelection != undefined && toAdd.customOptionsSelection.length > 0) {
                    // console.log('!!!!!!!!', toAdd.Trip.customOptions)
                    let first = true
                    toAdd.customOptionsSelection.forEach((groupID) => {

                        if (first)
                            toAdd.GroupsPretty = toAdd.Trip.customOptions.find(option => option.ID === groupID).label;

                        else
                            toAdd.GroupsPretty = toAdd.GroupsPretty + ", " + toAdd.Trip.customOptions.find(option => option.ID === groupID).label;
                        first = false
                    })
                }

                if(participant.Payments === undefined)
                    participant.Payments = []
                console.log(participant.Payments)
                participant.Payments.forEach((payment) => {


        var paymentToReturn = {}
        Object.assign(paymentToReturn, payment)

        // console.log('globalData.$data.$payments', paymentToReturn)

                    paymentToReturn.participant = participant
                    toReturn.payments.push(paymentToReturn)
                    return

        let paymentParticipant = payment.Participants.find((part) => part.ParticipantID == participant._id)

        //console.log('was this part found', paymentParticipant)

        if (paymentParticipant != undefined) {

            if (!globalData.$data.$userData.permissions.includes('sales') && !globalData.$data.$userData.permissions.includes('admin'))
                paymentToReturn.Last4 = '****'

            paymentToReturn.Amount = paymentParticipant.Amount.toFixed(2)
            toAdd.Payments.push(paymentToReturn)
            paymentToReturn.participant = participant
            toReturn.payments.push(paymentToReturn)
        }

    })
                if(1==2) {

    toAdd.totalFee = toAdd.Payments
        .filter(({Type, Status, FeeInstallment}) => Status === 'Processed' &&
            Type === 'Adjustment' && FeeInstallment !== undefined)
        .reduce((a, b) => +a + +b.Amount, 0)
    if (toAdd.totalFee != undefined)
        toAdd.totalFee = -1 * Number(Number.parseFloat(toAdd.totalFee).toFixed(2));
    else
        toAdd.totalFee = 0;

    console.log('totalFee', toAdd.totalFee)

    toAdd.totalPaid = toAdd.Payments
        .filter(({Type, Status}) => Status !== 'Pending' && Status !== 'Voided' &&
            (Type === 'Credit Card' || Type === 'E-Check' || Type === 'Adjustment'))
        .reduce((a, b) => +a + +b.Amount, 0);

    if (toAdd.totalPaid != undefined && toAdd.totalPaid > 0)
        toAdd.totalPaid = Number(Number.parseFloat(toAdd.totalPaid).toFixed(2));
    else
        toAdd.totalPaid = 0;

    toAdd.totalFundRaised = toAdd.Payments
        .filter(({Type, Status}) => Status === 'Processed' && Type === 'Fundraising')
        .reduce((a, b) => +a + +b.Amount, 0);

    if (toAdd.totalFundRaised != undefined)
        toAdd.totalFundRaised = Number(Number.parseFloat(toAdd.totalFundRaised).toFixed(2));
    else
        toAdd.totalFundRaised = 0;

    toAdd.totalPending = toAdd.Payments
        .filter(({Status}) => Status === 'Pending')
        .reduce((a, b) => +a + +b.Amount, 0);

    if (toAdd.totalPending != undefined)
        toAdd.totalPending = Number(Number.parseFloat(toAdd.totalPending).toFixed(2));
    else
        toAdd.totalPending = 0;


    //  console.log('MATCHING TRIP', participant.TripID)

    // START PAYMENT CALCULATIONS

    switch (participant.Occupancy) {
        case 1:
            toAdd.selectedTripCost = Number(toAdd.Trip.singlePrice)
            break;
        case 2:
            toAdd.selectedTripCost = Number(toAdd.Trip.doublePrice)
            break;
        case 3:
            toAdd.selectedTripCost = Number(toAdd.Trip.triplePrice)
            break;
        case 4:
            toAdd.selectedTripCost = Number(toAdd.Trip.quadPrice)
            break;

    }

    toAdd.totalRemaining = toAdd.selectedTripCost - (toAdd.totalFundRaised + toAdd.totalPaid)

    toAdd.Trip.depositAmount = Number(toAdd.Trip.depositAmount)

    //  toAdd.totalPending = 0
    //  toAdd.totalPaid = 1500

    toAdd.percentPaid = 100 * ((toAdd.totalFundRaised + toAdd.totalPaid) / toAdd.selectedTripCost)

    var costAtSignUp = Number(participant.costAtSignUp)

    var installmentAmounts = (toAdd.selectedTripCost - toAdd.Trip.depositAmount) / 4
    var installmentAmountscostAtSignUp = (costAtSignUp - toAdd.Trip.depositAmount) / 4

    let progress = (toAdd.totalFundRaised + toAdd.totalPaid + toAdd.totalFee - toAdd.Trip.depositAmount) / installmentAmountscostAtSignUp


    console.log('total maxPayment', toAdd.selectedTripCost - (Number(toAdd.totalFundRaised) + Number(toAdd.totalPaid) + Number(toAdd.totalPending)))

    toAdd.maxPayment = toAdd.selectedTripCost - (toAdd.totalFundRaised + toAdd.totalPaid + toAdd.totalPending)
    toAdd.minPayment = 0.10 * toAdd.selectedTripCost
    toAdd.defaultMinPayment = 0.10 * toAdd.selectedTripCost

    var paymentDues = []
    var paymentDuesTotals = []

    paymentDues.push({'date': toAdd.Trip.firstPaymentDueDate, 'amount': installmentAmountscostAtSignUp, 'progress': 1})
    paymentDues.push({'date': toAdd.Trip.secondPaymentDueDate, 'amount': installmentAmountscostAtSignUp, 'progress': 2})
    paymentDues.push({'date': toAdd.Trip.thirdPaymentDueDate, 'amount': installmentAmountscostAtSignUp, 'progress': 3})
    paymentDues.push({
        'date': toAdd.Trip.finalPaymentDueDate,
        'amount': toAdd.selectedTripCost - toAdd.Trip.depositAmount - (installmentAmountscostAtSignUp * 3),
        'progress': 4
    })


    var totalOverDue = 0 - (toAdd.totalFundRaised + toAdd.totalPaid)

    if ((toAdd.totalFundRaised + toAdd.totalPaid) >= toAdd.Trip.depositAmount)
        totalOverDue = totalOverDue + toAdd.Trip.depositAmount

    //   console.log('-------!!!!!!!!!!!!!!!!!!!!------------ daysToDo',totalOverDue)
    //  console.log(toAdd.selectedTripCost - (installmentAmountscostAtSignUp * 3))

    var forceFullPayment = false

    paymentDues.forEach((installmentPayment) => {
        var now = moment(new Date()); //todays date
        var end = moment(installmentPayment.date); // another date
        var duration = moment.duration(now.diff(end));
        var daysToDo = -1 * duration.asDays()


        if (daysToDo < 1) {
            totalOverDue = totalOverDue + installmentPayment.amount

            console.log('-------!!!!!!!!!!!!!!!!!!!!------------ daysToDo', totalOverDue)
        }

    })

    if (totalOverDue < 0) {
        totalOverDue = 0
    }

    totalOverDue += toAdd.totalFee;

    console.log('FEES', toAdd.totalFee)

    toAdd.totalOverDue = totalOverDue

    if (toAdd.Trip.depositAmount > (toAdd.totalFundRaised + toAdd.totalPaid + toAdd.totalPending))
        toAdd.minPayment = toAdd.depositAmount

    if (toAdd.maxPayment < toAdd.minPayment) {
        toAdd.minPayment = toAdd.maxPayment
    }

    if (toAdd.Trip.depositAmount > (toAdd.totalFundRaised + toAdd.totalPaid)) {
        toAdd.PaymentProgress = 0
    } else if (progress < 0) {
        toAdd.PaymentProgress = 1
    } else {
        toAdd.PaymentProgress = (Math.trunc(progress)) + 1
    }

    if (toAdd.PaymentProgress > 4) {
        toAdd.PaymentProgress = 4
    }

    switch (toAdd.PaymentProgress) {
        case 0:
            //  console.log('**************************************************0000000000')

            if (toAdd.Trip.depositPaymentDueDate == undefined || toAdd.Trip.depositPaymentDueDate == null) {
                toAdd.nextDue = moment(participant.createdAt).add(14, 'day');
            } else {
                toAdd.nextDue = toAdd.Trip.depositPaymentDueDate
            }
            if (forceFullPayment) {
                toAdd.dueAmount = totalOverDue
                toAdd.recommendedPayment = '$' + toAdd.dueAmount + ' ($' + toAdd.Trip.depositAmount + ' deposit + $' + (totalOverDue - toAdd.Trip.depositAmount) + ' overdue)'

            } else {
                toAdd.dueAmount = toAdd.Trip.depositAmount + totalOverDue
                console.log(toAdd.Trip.depositAmount, totalOverDue)
                toAdd.recommendedPayment = '$' + toAdd.dueAmount + ' ($' + toAdd.Trip.depositAmount + ' deposit + $' + totalOverDue + ' overdue)'
            }
            toAdd.minPayment = toAdd.dueAmount
            if (moment().isBefore(moment(toAdd.nextDue).add(14, 'days'))) {
                toAdd.minPayment = toAdd.Trip.depositAmount
            }

            break;
        case 1:
            if ((toAdd.totalFundRaised + toAdd.totalPaid + toAdd.totalPending) == toAdd.Trip.depositAmount
                && participant.costAtSignUp != toAdd.selectedTripCost) {
                console.log('UPDATING COST AT SIGN UP!')
                installmentAmountscostAtSignUp = installmentAmounts
                if (globalData.$data.$userData.permissions.includes('admin'))
                    this.$services.participants.patch(participant._id,
                        {
                            'costAtSignUp': toAdd.selectedTripCost
                        }).then((result) => {


                    })
            }
            toAdd.nextDue = toAdd.Trip.firstPaymentDueDate
            toAdd.dueAmount = (installmentAmountscostAtSignUp) - (toAdd.totalFundRaised + toAdd.totalPaid - toAdd.Trip.depositAmount)

            //   console.log('in 1!!!!!!!! cost at sign up', toAdd.dueAmount)
            break;
        case 2:
            toAdd.nextDue = toAdd.Trip.secondPaymentDueDate
            toAdd.dueAmount = (installmentAmountscostAtSignUp * toAdd.PaymentProgress) - (toAdd.totalFundRaised + toAdd.totalPaid - toAdd.Trip.depositAmount)
            //  console.log('in 2!!!!!!!! cost at sign up', toAdd.dueAmount)
            break;
        case 3:
            toAdd.nextDue = toAdd.Trip.thirdPaymentDueDate
            toAdd.dueAmount = (installmentAmountscostAtSignUp * toAdd.PaymentProgress) - (toAdd.totalFundRaised + toAdd.totalPaid - toAdd.Trip.depositAmount)
            //  console.log('in 3!!!!!!!! cost at sign up', toAdd.dueAmount)
            break;
        case 4:
            /*toAdd.nextDue = toAdd.Trip.finalPaymentDueDate
            toAdd.nextDueAmount = (toAdd.selectedTripCost  - (toAdd.totalFundRaised + toAdd.totalPaid))
            console.log('in 3!!!!!!!! cost at sign up', toAdd.nextDueAmount)*/
            toAdd.nextDue = toAdd.Trip.finalPaymentDueDate
            toAdd.dueAmount = (installmentAmounts * toAdd.PaymentProgress) - (toAdd.totalFundRaised + toAdd.totalPaid - toAdd.Trip.depositAmount)
            //  console.log('in 4!!!!!!!! cost at sign up', toAdd.dueAmount)

            break;

    }


    toAdd.percentPaid = 100 * ((toAdd.totalFundRaised + toAdd.totalPaid) / toAdd.selectedTripCost)
    // console.log('-------!!!!!!!!!!!!!!!!!!!!------------',toAdd.dueAmount,  totalOverDue)
    if (toAdd.dueAmount < totalOverDue) {
        console.log('due amount vs overdue!', toAdd.dueAmount, totalOverDue)

        toAdd.dueAmount = totalOverDue

        toAdd.recommendedPayment = '$' + toAdd.dueAmount + ' (overdue)'

    } else if (toAdd.PaymentProgress > 0) {
        toAdd.recommendedPayment = '$' + toAdd.dueAmount + ''
    }


    if (toAdd.minPayment > toAdd.dueAmount) {
        toAdd.minPayment = toAdd.dueAmount
    } else if (toAdd.maxPayment < toAdd.dueAmount) {
        toAdd.maxPayment = toAdd.dueAmount
    }


    paymentDuesTotals.push({'date': toAdd.Trip.depositPaymentDueDate, 'amount': toAdd.Trip.depositAmount})
    paymentDuesTotals.push({
        'date': toAdd.Trip.firstPaymentDueDate,
        'amount': installmentAmountscostAtSignUp + toAdd.Trip.depositAmount
    })
    paymentDuesTotals.push({
        'date': toAdd.Trip.secondPaymentDueDate,
        'amount': (installmentAmountscostAtSignUp * 2) + toAdd.Trip.depositAmount
    })
    paymentDuesTotals.push({
        'date': toAdd.Trip.thirdPaymentDueDate,
        'amount': (installmentAmountscostAtSignUp * 3) + toAdd.Trip.depositAmount
    })
    paymentDuesTotals.push({'date': toAdd.Trip.finalPaymentDueDate, 'amount': toAdd.selectedTripCost})

    var totalApplied = toAdd.totalFundRaised + toAdd.totalPaid

}
                let paymentNextDueIndex = null

                if(participant.paymentDuesTotals === undefined) {
                    let paymentDuesTotals = []
                    paymentDuesTotals.push({'date': toAdd.Trip.depositPaymentDueDate, 'amount': toAdd.Trip.depositAmount})
                    paymentDuesTotals.push({
                        'date': toAdd.Trip.firstPaymentDueDate,
                        'amount': installmentAmountscostAtSignUp + toAdd.Trip.depositAmount
                    })
                    paymentDuesTotals.push({
                        'date': toAdd.Trip.secondPaymentDueDate,
                        'amount': (installmentAmountscostAtSignUp * 2) + toAdd.Trip.depositAmount
                    })
                    paymentDuesTotals.push({
                        'date': toAdd.Trip.thirdPaymentDueDate,
                        'amount': (installmentAmountscostAtSignUp * 3) + toAdd.Trip.depositAmount
                    })
                    paymentDuesTotals.push({'date': toAdd.Trip.finalPaymentDueDate, 'amount': toAdd.selectedTripCost})

                    participant.paymentDuesTotals = paymentDuesTotals
                }

                participant.paymentDuesTotals.forEach((installmentPayment, i) => {
                    let now = moment(new Date()); //todays date
                    let dueDate = moment(installmentPayment.date);
                    let millisecondsToDueDate = dueDate.diff(now)

                 //   console.log('millisecondsToDueDate', millisecondsToDueDate)
                    if (millisecondsToDueDate > 0 && paymentNextDueIndex === null) {
                        paymentNextDueIndex = i
                   //     console.log('first due date in the future is', dueDate, installmentPayment)
                    }
                })

                if (paymentNextDueIndex === null) {
                    paymentNextDueIndex = participant.paymentDuesTotals.length - 1
                }


                toAdd.color = "green"
                toAdd.icon = "date_range"

                var now = moment(new Date()); //todays date
                var end = moment(toAdd.nextDue); // another date
                var duration = moment.duration(now.diff(end));


                if (toAdd.percentPaid == 100) {
                    toAdd.color = "green"
                    toAdd.icon = "check_circle"
                }
                else if (toAdd.daysToDue < 3) {
                    toAdd.color = "red"
                } else if (toAdd.daysToDue < 8) {
                    toAdd.color = "orange"
                } else if (toAdd.PaymentProgress == 0) {
                    toAdd.color = "red"
                } else {
                    toAdd.color = "green"
                }

                toAdd.Payments.sort(function(a,b){
                    // Turn your strings into dates, and then subtract them
                    // to get a value that is either negative, positive, or zero.
                    //console.log('dates', b.Date, a.Date)
                    return new Date(b.Date) - new Date(a.Date);
                });
                toReturn.participants.push(toAdd)

            })


             console.log('before notifications foreach',toReturn.notifications)



            toReturn.notifications.forEach((notification) => {
            //    console.log('notif',notification)
                notification.dateFormatted = moment(notification.date).format('MMM Do')
                if(notification.trip != undefined)
                    notification.tripName = globalData.$data.$trips.find(trip => trip._id === notification.trip).tripName;
                notification.readStatuses = []
                notification.readCount = 0
                notification.unreadCount = 0

                //     console.log('finding users connected to notif', notification)
                releventUsers.forEach((user) => {
                    if (user.permissions[0] == "adult" && (user.trips.includes(notification.trip) || notification.user == user._id)) {
                        //        console.log('checking notifs for user', user.notifsReadList)
                        if (user.notifsReadList == undefined || !user.notifsReadList.includes(notification._id)) {
                            notification.readStatuses.push(
                                {
                                    "read": false,
                                    "type": 'parent',
                                    "user": user
                                })
                            notification.unreadCount++
                        } else if (user.notifsReadList.includes(notification._id)) {
                            notification.readStatuses.push(
                                {
                                    "read": true,
                                    "type": 'parent',
                                    "user": user
                                })
                            notification.readCount++
                        }
                    }
                })


            })


            if (globalData.$data.$userData.permissions.includes('admin')) {

                toReturn.trips.forEach((trip) => {

                    var depAmount = Number(trip.depositAmount)

                  //  console.log('this trip', depAmount)
                 //   console.log('toReturn.participants', toReturn.participants)
                    var participantsPaid = toReturn.participants.filter(
                        ({totalFundRaised, totalPaid, Trip}) => Trip._id == trip._id && (totalFundRaised + totalPaid) >= depAmount).length

                 //   console.log('IN PARTICIPANT COUNT FUNCTION', trip.participantCount, participantsPaid)
                    if (trip.participantCount != participantsPaid) {
                        console.log('updating participant count')
                           this.$services.trips.patch(trip._id,
                               {
                                   'participantCount' : participantsPaid
                               }).then((result) => {
                               trip.participantCount = participantsPaid
                               console.log('updated participant count')
                           })
                    }

                })
            }

            toReturn.payments.sort(function(a,b){
                // Turn your strings into dates, and then subtract them
                // to get a value that is either negative, positive, or zero.
               // console.log('dates', b.Date, a.Date)
                return new Date(b.Date) - new Date(a.Date);
            });

            console.log('RETURNING!!!!!!!!', toReturn)
            globalData.$data.$busyDialog = false
            return toReturn
        }

    }
})




/*

feathers.authenticate({
    strategy: 'local',
    email: 'admin@test.com',
    password: 'adminpass',
    entity: 'user',
    service: 'users',

})
    .then(response => {
        console.log('Authenticated!', response);
        return feathers.passport.verifyJWT(response.accessToken);
    })
    .then(payload => {
        //console.log('JWT Payload', payload);
        return feathers.service('users').get(payload.userId);
    })
    .then(user => {
        feathers.set('user', user);
        //console.log('User', app.get('user'));
    })
    .catch(function(error){
        console.error('Error authenticating!', error);
    });

/*

app.service('trips').find()
    console.log('User', app.get('user'));
    app.service('trips').create({ "tripID": "2343",
        "tripName": "Test Trip 2"}, {})
 */
// Connect to the `http://feathers-api.com/messages` service





const vueFeathers = require('vue-feathers')

// And plug it in
Vue.use(vueFeathers, feathersApp)

Vue.use(require('vue-moment'));

Vue.config.productionTip = false

import documents from './pages/Documents'
import tripnews from './pages/TripNews'
import participants from './pages/Participants'
import payments from './pages/Payments'
import forms from './pages/Forms'
import reports from './pages/Reports'
import trips from './pages/Trips'
import trip from './pages/Trip'
import users from './pages/Users'
import login from './pages/Login'
import connecting from './pages/Connecting'
import newtrip from './pages/NewTrip'
import selecttrip from './pages/SelectTrip'
import register from './pages/Register'
import recovery from './pages/Recovery'
import verify from './pages/Verify'
import profile from './pages/Profile'
import setup from './pages/Setup'
import addtrip from './pages/AddTrip'
import addtraveler from './pages/AddTraveler'
import makepayment from './pages/MakePayment'
import newbusiness from './pages/NewBusiness'
import businesses from './pages/Businesses'

import directordashboard from './pages/DirectorDashboard'
import admindashboard from './pages/AdminDashboard'
import dashboard from './pages/Dashboard'
import addFundraising from './pages/FundRaising'
import massAdjustment from './pages/MassAdjustment'

import tripinfo from './pages/TripInfo'

const routes = [
    { path: '/', component: dashboard },
    { path: '/CustomerDashBoard', component: dashboard },
    { path: '/DirectorDashboard', component: directordashboard },
    { path: '/AdminDashboard', component: admindashboard },
    { path: '/Documents', component: documents },
    { path: '/TripNews', component: tripnews },
    { path: '/Participants', component: participants },
    { path: '/Payments', component: payments },
    { path: '/Reports', component: reports },
    { path: '/Trips', component: trips },
    { path: '/Trip', component: trip },
    { path: '/NewTrip', component: newtrip},
    { name: "updatetrip", path: '/UpdateTrip/:id', component: newtrip },
    { path: '/Users', component: users },

    { name: "login", path: '/Login', component: login },
    { name: "tripinfo", path: '/TripInfo/:id', component: tripinfo },
    { name: "connecting", path: '/Connecting', component: connecting },
    { name: "register", path: '/Register', component: register },
    { name: "recovery", path: '/reset', component: register },
    { name: "recovery", path: '/Recovery', component: recovery },
    { name: "verify", path: '/Verify', component: verify },
    { name: "selecttrip", path: '/SelectTrip', component: selecttrip },
    { name: "profile", path: '/Profile', component: profile },
    { name: "profile", path: '/Profile/:id', component: profile },
    { name: "setup", path: '/Setup', component: setup },
    { name: "addtraveler", path: '/AddTraveler', component: addtraveler },
    { name: "addtrip", path: '/AddTrip', component: addtrip },
    { name: "makepayment", path: '/MakePayment', component: makepayment },
    { name: "forms", path: '/Forms', component: forms },
    { path: '/FundRaising', component: addFundraising },
    { path: '/FundRaising', component: addFundraising },
    { path: '/MassAdjustment', component: massAdjustment },

    { name: "addbusiness", path: '/AddBusiness', component: newbusiness },
    { name: "updatebusiness", path: '/UpdateBusiness/:id', component: newbusiness },

    { name: "businesses", path: '/Businesses', component: businesses }
]

const router = new VueRouter({
    routes // short for `routes: routes`
})

router.afterEach((to, from) => {
   // console.log('after each', to, from)
    if (from.name == "login") {
       // router.go()
    }
})

router.beforeEach((to, from, next) => {
   // console.log('router before each', to, from)
    if(to.name == "login" || to.name == "register" || to.name == "recovery" || to.name == "verify"  || to.name == "connecting"|| to.name == "tripinfo" ) {
        next()
    } else if (feathersApp.get('user') == undefined) {
        next('/Login')
    } else if (!feathersApp.get('user').isVerified) {
     //   console.log('forcing verify')
        next('/Verify')
    } else if ((!globalData.$data.$userData.setup || globalData.$forceSetupAgain) && to.name != "setup" ) {
       console.log('forcing setup')
        next('/Setup')
    } else if (to.name != "setup" &&  to.name != "addtrip" && window.$cookies.isKey("tripToAdd")) {
        console.log('triptoadd cookie exists', to.name)
        next('/AddTrip')
    } else if (to.name !="setup" && to.name != "selecttrip" && to.name != "addtrip" && feathersApp.get('user').permissions[0] == "adult" && globalData.$data.$forceSelectTrip) {
           console.log('forcing trip choice')
        next('/SelectTrip')
    } else if (to.path == "/") {
      //  console.log('dashboard request', to, feathers.get('user'))
        if(feathersApp.get('user').permissions[0] == "director")   {
            next('/DirectorDashboard')
        } else if (feathersApp.get('user').permissions[0] == "admin" || feathersApp.get('user').permissions[0] == "sales")  {
            next('/AdminDashboard')
        } else {
            next()
        }

    } else {
        next()
    }
})



feathersApp.authenticate()
    .then(response => {
        console.log('Authenticated in main!', response);
        return feathersApp.passport.verifyJWT(response.accessToken);
    })
    .then(payload => {
        console.log('JWT Payload in main', payload);
        return feathersApp.service('users').get(payload.userId);
    })
    .then(user => {
        console.log('User logged in...... in main', user);
        feathersApp.set('user', user);
        globalData.$data.$userData = user
        globalData.$data.$busyDialog = true

    })
    .catch(function(error){
        console.log('Error authenticating!!!!!!!!!!!! in main', error);
    })
    .finally(() => {
        console.log('FINALLY! in main')

        new Vue({
            router,
            render: h => h(App),
        }).$mount('#app')

    })

var failed = 0

function heartBeat() {
    if(navigator.onLine) {
        var xhr = new XMLHttpRequest();
        console.log('checking pulse')
        xhr.open('GET', 'https://api.grouptravelplanners.com/heartbeat');
        xhr.onload = function () {
            if (xhr.status !== 200) {
                failed++
                console.log('failed check')
                if(failed > 2)
                    window.location.replace("https://ips.grouptravelplanners.com/#/Connecting");
            } else {
                console.log('got a pulse')

                if(failed > 2) {
                    window.location.replace("https://ips.grouptravelplanners.com/");
                }
                failed = 0;
            }
        };
        xhr.onerror = function(e){
            failed++
            console.log('failed check')
            if(failed > 2)
                window.location.replace("https://ips.grouptravelplanners.com/#/Connecting");
        };

        xhr.send();
    }
}

function startHeartMon() {
    window.setInterval(function () {
        heartBeat()
    }, 5000);
}
